export const styles = {
  root: {
    overflow: 'hidden',
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '80px',
    height: 'calc(100svh)',
  },
};
